import styled from 'styled-components';

export const NavWrapper = styled.div`
  position: fixed;
  bottom: 0;
  /* The sidenav rail is structural chrome and stays at the low layer2 (300), below the
     StormUI FocusOverlay layer3/500 and the Sheet/Modal layer4/700), so any focus
     surface covers the rail. A fixed value between the layers (e.g. 501) can't work: it
     would also form a stacking context that traps the sidenav's OWN popovers. Instead,
     the sidenav's popovers/flyouts escape ABOVE every focus surface by portalling into
     SidenavPopoverPortal (escalated to ~10000 via useEscalatedPortalZIndex). Chrome-level
     FOCUS / FOCUS_NO_HEADER layouts don't render Nav at all (shouldRenderMenu). */
  z-index: ${({ theme }) => theme.elevation.zIndex.layer2};
`;

/**
 * Host that sidenav popovers portal into (future feature-highlight popovers, etc.).
 * `position: relative` is load-bearing: it lets the z-index that `Nav` assigns at
 * runtime via `useEscalatedPortalZIndex` (nearest-ancestor + inline-portal increment)
 * form a stacking context. It sits OUTSIDE `NavWrapper` (which has `overflow: hidden`)
 * so a popover can escape the rail, and the runtime escalation lets an explicitly-opened
 * sidenav popover paint above a StormUI `FocusOverlay` even though the rail itself stays
 * below it. No sidenav popover exists today; this is future-proofing.
 */
export const SidenavPopoverPortal = styled.div`
  position: relative;
`;
